export const marketingQuest = {
  id: "marketing-quest",
  code: "03",
  brand: "Marketing Quest",
  nameJa: "マーケティング支援",
  nameEn: "Growth Marketing",
  accent: "primary",
  icon: "ri-line-chart-line",
  taglineJa: "事業成長のボトルネックを、経験のあるマーケターが解く。",
  taglineEn: "Senior marketers who unblock your growth.",
  leadJa:
    "大手事業会社・広告代理店出身のマーケターが、事業戦略からチャネル設計、広告運用、データ分析までを担当します。まず現状の数字を分解し、伸ばせるポイントを特定するところから始めます。",
  leadEn:
    "Ex-enterprise and agency marketers cover strategy, channel design, media buying and analytics — starting with a hard look at your numbers.",
  heroImage:
    "/images/marketing.jpg",
  stats: [
    { value: "140", unit: "社", labelJa: "累計支援企業", labelEn: "Clients supported" },
    { value: "34", unit: "%", labelJa: "CPA 平均改善", labelEn: "Average CPA improvement" },
    { value: "3.2", unit: "億円", labelJa: "月間運用広告費", labelEn: "Monthly media spend" },
    { value: "22", unit: "名", labelJa: "在籍マーケター", labelEn: "In-house marketers" },
  ],
  challenges: [
    {
      icon: "ri-money-cny-circle-line",
      titleJa: "広告費は増えたのに成果が伸びない",
      titleEn: "Spend up, results flat",
      descJa: "媒体を増やしてもCPAが改善せず、予算の配分判断が感覚になっていませんか。",
    },
    {
      icon: "ri-bar-chart-box-line",
      titleJa: "施策の効果が測れていない",
      titleEn: "No measurement",
      descJa: "何が効いたのか分からないまま次の施策に進み、学習が積み上がっていないケースが多くあります。",
    },
    {
      icon: "ri-user-settings-line",
      titleJa: "内製化したいがノウハウがない",
      titleEn: "Cannot go in-house",
      descJa: "採用はできたものの、運用の型や指標の設計がなく、属人的な運用に戻ってしまうことがあります。",
    },
  ],
  strengths: [
    {
      icon: "ri-compass-3-line",
      titleJa: "事業会社出身の戦略設計",
      titleEn: "Operator-side strategy",
      descJa: "代理店側ではなく事業会社側で数字を見てきたメンバーが、事業計画から逆算して設計します。",
    },
    {
      icon: "ri-pencil-ruler-2-line",
      titleJa: "クリエイティブまで一気通貫",
      titleEn: "Creative included",
      descJa: "グループのProDesignと連携し、配信面のデザイン・動画制作まで同じチームで回せます。",
    },
    {
      icon: "ri-dashboard-3-line",
      titleJa: "ダッシュボードの構築",
      titleEn: "Live dashboards",
      descJa: "媒体・GA4・CRMの数字を1枚に統合し、いつでも同じ指標で判断できる状態をつくります。",
    },
    {
      icon: "ri-graduation-cap-line",
      titleJa: "内製化までの伴走",
      titleEn: "Enablement",
      descJa: "運用マニュアルと研修をセットで提供し、最終的に社内で回せる状態まで持っていきます。",
    },
  ],
  menu: [
    {
      icon: "ri-route-line",
      titleJa: "マーケティング戦略設計",
      titleEn: "Marketing strategy",
      descJa: "市場・競合・顧客の整理から、獲得チャネルの優先順位とKPIツリーを設計します。",
    },
    {
      icon: "ri-advertisement-line",
      titleJa: "広告運用",
      titleEn: "Media buying",
      descJa: "Google・Meta・X・LINE・Yahoo!の運用型広告を、日次で改善しながら運用します。",
    },
    {
      icon: "ri-search-line",
      titleJa: "SEO・コンテンツ",
      titleEn: "SEO & content",
      descJa: "検索意図の整理から記事設計、内部リンク設計、改善までを継続的に回します。",
    },
    {
      icon: "ri-mail-send-line",
      titleJa: "CRM・MA構築",
      titleEn: "CRM & automation",
      descJa: "リードの獲得から育成、商談化までの導線を設計し、MAツールの構築・運用を行います。",
    },
    {
      icon: "ri-flask-line",
      titleJa: "ABテスト・分析",
      titleEn: "Testing & analytics",
      descJa: "LPやクリエイティブのABテストを設計し、結果を次の施策に接続します。",
    },
  ],
  pricing: [
    {
      nameJa: "診断プラン",
      nameEn: "Audit",
      price: "150,000円〜",
      priceNote: "税別 / 単発",
      descJa: "まず現状を整理したい企業向けのスポット診断。",
      features: ["広告アカウント診断", "GA4・CRMの計測確認", "改善優先度の整理", "報告書＋60分解説"],
      recommended: false,
    },
    {
      nameJa: "運用支援プラン",
      nameEn: "Performance retainer",
      price: "月額 300,000円〜",
      priceNote: "税別 / 広告費別",
      descJa: "広告運用を中心に、毎月の改善を回したい企業向け。",
      features: ["広告運用（2媒体まで）", "クリエイティブ改善提案", "月次レポート＋定例MTG", "ダッシュボード構築"],
      recommended: true,
    },
    {
      nameJa: "包括支援プラン",
      nameEn: "Full-funnel retainer",
      price: "月額 600,000円〜",
      priceNote: "税別 / 広告費別",
      descJa: "戦略から実行まで、マーケティング全体を任せたい企業向け。",
      features: ["戦略設計＋KPI管理", "広告・SEO・MAの横断運用", "クリエイティブ制作", "内製化トレーニング"],
      recommended: false,
    },
  ],
  priceNoteJa: "表示金額はすべて税別の目安です。支援範囲と広告予算に応じて個別にお見積りします。",
  flow: [
    { step: "01", titleJa: "無料相談", titleEn: "Consultation", descJa: "現状の課題と目標をオンラインで伺います。" },
    { step: "02", titleJa: "現状分析", titleEn: "Audit", descJa: "広告アカウント・GA4・CRMの数字を分解します。" },
    { step: "03", titleJa: "戦略提案", titleEn: "Strategy", descJa: "優先順位・KPI・体制・費用をセットでご提案します。" },
    { step: "04", titleJa: "運用・改善", titleEn: "Run & optimize", descJa: "月次で振り返りながら、改善を継続します。" },
  ],
  faq: [
    { q: "広告予算が月30万円でも依頼できますか？", a: "はい。予算規模に合わせて運用範囲を調整します。小規模の場合は媒体を1〜2に絞り、学習が回る形に設計します。" },
    { q: "広告費は支援費に含まれますか？", a: "含まれません。支援費はコンサルティング・運用の費用で、広告費は媒体へ直接お支払いいただく形になります。" },
    { q: "最低契約期間はありますか？", a: "3ヶ月を目安としています。運用型広告は学習に時間がかかるためです。以降は1ヶ月単位で更新します。" },
    { q: "社内にマーケターがいなくても大丈夫ですか？", a: "問題ありません。実務はこちらで担い、並行して社内の方が運用を学べる研修プログラムも用意しています。" },
  ],
  related: ["prodesign", "pro-online"],
};